$(document).ready(function () {
  $('#custom-hero-slider .hero-slider__inner').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 300,
    infinite: true,
    arrows: false,
    dots: true,
    fade: false,
    pauseOnHover: true
  });
});


// Product Detail Page tab Section js Start

document.addEventListener('DOMContentLoaded', function () {

  const buttons = document.querySelectorAll('.product-tab-btn');
  const contents = document.querySelectorAll('.product-tab-content');

  buttons.forEach(function (button) {

    button.addEventListener('click', function () {

      const tab = this.getAttribute('data-tab');

      buttons.forEach(function (btn) {
        btn.classList.remove('active');
      });

      contents.forEach(function (content) {
        content.classList.remove('active');
      });

      this.classList.add('active');

      const activeContent = document.getElementById(tab);

      if (activeContent) {
        activeContent.classList.add('active');
      }

    });

  });

});

document.addEventListener('DOMContentLoaded', function () {
  function movePickupButton() {
    const button = document.querySelector(
      '.pickup-availability-info .pickup-availability-button'
    );

    const target = document.querySelector(
      '.product-pickup-info__text > span'
    );

    if (button && target && !target.previousElementSibling?.matches('.pickup-availability-button')) {
      target.before(button);
    }
  }

  movePickupButton();

  const observer = new MutationObserver(movePickupButton);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

function checkPickupAvailability() {
  const button = document.getElementById('ShowPickupAvailabilityDrawer');

  document.querySelectorAll('.product-pickup-info').forEach(function (element) {
    element.style.display = button ? '' : 'none';
  });
}

document.addEventListener('DOMContentLoaded', checkPickupAvailability);

new MutationObserver(checkPickupAvailability).observe(document.body, {
  childList: true,
  subtree: true
});



// faq js start

document.addEventListener("DOMContentLoaded", function () {

  const items = document.querySelectorAll(".faq-item");

  items.forEach(item => {

    item.querySelector(".faq-question").addEventListener("click", function () {

      // Close other FAQ items
      items.forEach(i => {
        if (i !== item) {
          i.classList.remove("active");
          i.querySelector(".faq-answer").style.display = "none";
        }
      });

      // Toggle current FAQ
      item.classList.toggle("active");

      const answer = item.querySelector(".faq-answer");

      if (item.classList.contains("active")) {
        answer.style.display = "block";
      } else {
        answer.style.display = "none";
      }

    });

  });

});
